import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=1a82b5ab&scoped=true"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"
import style0 from "./Sms.vue?vue&type=style&index=0&id=1a82b5ab&prod&scoped=true&lang=scss"
import style1 from "./Sms.vue?vue&type=style&index=1&id=1a82b5ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82b5ab",
  null
  
)

export default component.exports